module.exports = __webpack_public_path__ + "static/crosslink-7ee4101c3cfd99ca7413101e82a5ba2e.jpg";